export const getCandidateDetails = (api, payload, tokenType) => {
  const { id } = payload;
  return api.get(`/candidates/${id}`, { tokenType });
};
